import { IconName, LookbackOption } from '@talos/kyoko';
import { v1 as uuid } from 'uuid';
import type { EntityName, MonitoringBlotterTabProps } from './types';

export const DEFAULT_MONITORING_BLOTTER_TABS = [
  {
    label: 'Default',
    id: uuid(),
    defaultColumns: [],
    defaultFilter: {
      _start: LookbackOption.Past24Hours,
      HideAPICalls: true,
    },
    name: 'Order',
    closable: true,
    reorderable: true,
    editable: true,
  },
] satisfies MonitoringBlotterTabProps[];

export const MonitoringIconLookup = {
  OMS: IconName.Collection,
  Market: IconName.PresentationChartLine,
  Customer: IconName.UserCircle,
  Care: IconName.ListGroup,
} as const;

/** Icons for individual monitoring panels in the layout add-panel menu (`PanelComponentSpec.icon`). */
export const MonitoringEntityPanelIconLookup: Partial<Record<EntityName, IconName>> = {
  AssetTransaction: IconName.Cash,
  BuyingPower: IconName.Wallet,
  Index: IconName.PresentationChartLine,
  IndexMark: IconName.Pin,
  Notification: IconName.Bell,
};
